export const theme = {
  whitelabel: true,
  iconUrl: '/assets/misresultados/img/PNG/icon.png',
  name: 'MisResultados',
  lis: "MisResultados",
  play_container:{
    app_store: "https://apps.apple.com/us/app/misresultados/id1581001319",
    play_store: "https://play.google.com/store/apps/details?id=com.abartyshealth.misresultados"
  }
};
